export const handleStatusUploadFile = (event = {}) => {
  const count = Math.round((100 * event.loaded) / event.total);
  if (count < 100) {
    return count;
  } else {
    return 0;
  }
}